import styles from "../assets/styles/componenets/teachers.module.css";
import { useTeacherContext } from "../context/teacherCVContext";
import { useState, useEffect } from "react";
import PDFViewer from "./PDFViewer";

function TeacherCv() {
    const { selectedTeacher, setSelectedTeacher } = useTeacherContext();
    const [loading, setLoading] = useState(true);
    const [isMobileView, setIsMobileView] = useState(null);

    useEffect(() => {
        const checkMobile = () => {
            const aspectRatio = window.innerWidth / window.innerHeight;
            setIsMobileView(aspectRatio < 1 || window.innerWidth < 650);
        };

        checkMobile();
    }, []);

    const pdfUrl = `${window.location.origin}/cvs/${selectedTeacher}.pdf`;

    return (
        <div className={styles.cvmodal}>
            <button onClick={() => setSelectedTeacher(null)}>✖</button>

            {(loading || isMobileView === null) && (
                <div className={styles.loadingOverlay}>
                    <div className={styles.spinner}></div>
                </div>
            )}

            {isMobileView ? (
                <PDFViewer
                    url={pdfUrl}
                    onRenderComplete={() => setLoading(false)}
                />
            ) : (
                <div className={styles.iframeContainerMain}>
                    <div className={styles.iframeContainer}>
                    <iframe
                        src={pdfUrl}
                        title={`${selectedTeacher} CV`}
                        onLoad={() => setLoading(false)}
                        className={
                            !loading
                                ? styles.iframeVisible
                                : styles.iframeHidden
                        }
                    />
                </div>
                </div>
            )}
        </div>
    );
}

export default TeacherCv;

/**
 * <iframe
                key={key} // ✅ force full remount to avoid broken Google cache
                ref={iframeRef}
                src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(window.location.origin + '/cvs/' + selectedTeacher + '.pdf')}?t=${Date.now()}`}
                title={`${selectedTeacher} CV`}
                width="100%"
                height="100%"
                onLoad={() => {
                    setTimeout(() => setLoading(false), 200);
                }}
                className={!loading ? styles.iframeVisible : styles.iframeHidden}
            />
 */
